import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {PaymentMode, PaymentModes} from '../../model/order/dcp-order.model';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {OccEndpointsService} from '@spartacus/core';
import {DcpCustomConfig} from '../../config/DcpCustomConfig';

@Injectable({
  providedIn: 'root'
})
export class PaymentModeService {

  constructor(private http: HttpClient,
              private occEndpointsService: OccEndpointsService) {
  }

  /**
   * Fetch payment modes
   */
  public fetchPaymentModes(): Observable<PaymentMode[]> {
    const url: string = this.occEndpointsService.buildUrl(DcpCustomConfig.custom.endpoints.paymentModes);
    return this.http.get<PaymentModes>(url)
      .pipe(
        map((data: PaymentModes) => data.paymentModes)
      );
  }
}
